export const common = {
  // Navigation
  'nav.features': 'Functies',
  'nav.howItWorks': 'Hoe het werkt',
  'nav.pricing': 'Prijzen',
  'nav.faq': 'FAQ',
  'nav.aboutUs': 'Over ons',
  'nav.getStarted': 'Aan de slag',

  // About Us Section
  'aboutUs.badge': 'Over ons',
  'aboutUs.title': 'Over ons',
  'aboutUs.line1': 'Ideeën zijn goedkoop.',
  'aboutUs.line2': 'Kapitaal niet. Tijd al helemaal niet.',
  'aboutUs.paragraph1': 'IdeaOracle.ai werd opgericht omdat de meeste bedrijfsideeën niet falen door gebrek aan moed – maar door gebrek aan eerlijkheid. Te veel bevestiging. Te weinig realiteit.',
  'aboutUs.belief1a': 'We geloven niet in hype.',
  'aboutUs.belief1b': 'We geloven in marktlogica.',
  'aboutUs.belief2a': 'We geloven niet in motivatie.',
  'aboutUs.belief2b': 'We geloven in vraag, concurrentie en differentiatie.',
  'aboutUs.mission1': 'Onze taak is niet om ideeën er goed uit te laten zien.',
  'aboutUs.mission2': 'Onze taak is om hun levensvatbaarheid bloot te leggen.',
  'aboutUs.analysis': 'IdeaOracle.ai analyseert zakelijke niches op structurele marktmechanica, realistische vraag, concurrentie-intensiteit en haalbaarheid. Niet emotioneel. Niet optimistisch. Maar nuchter.',
  'aboutUs.failure1': 'De meeste ideeën falen.',
  'aboutUs.failure2': 'Niet omdat oprichters onbekwaam zijn –',
  'aboutUs.failure3': 'maar omdat niemand vooraf duidelijk genoeg was.',
  'aboutUs.clarity': 'Wij bestaan om die duidelijkheid te leveren.',
  'aboutUs.value1': 'Ongemakkelijk.',
  'aboutUs.value2': 'Direct.',
  'aboutUs.value3': 'Consequent.',
  'aboutUs.confirm': 'Als een idee substantie heeft, bevestigen we het.',
  'aboutUs.deny': 'Zo niet, dan zeggen we dat ook.',
  'aboutUs.noApplause': 'Zonder applaus.',
  'aboutUs.noSugarcoating': 'Zonder mooipraterij.',
  'aboutUs.noTheater': 'Zonder theater.',

  // Hero Section
  'hero.badge': 'Beslissings-AI voor zakelijke niches',
  'hero.title1': 'Ideeën zijn goedkoop.',
  'hero.title2': 'Slechte beslissingen niet.',
  'hero.subtitle': 'Een AI die je zakelijke niche evalueert',
  'hero.subtitleLine2': 'voordat je investeert.',
  'hero.cta': 'Idee controleren',
  'hero.ctaSecondary': 'Hoe het werkt',
  'hero.stat1Value': '30',
  'hero.stat1Label': 'Credits per aanvraag',
  'hero.stat2Value': 'Vanaf 7',
  'hero.stat2Label': 'Beoordelingsniveaus',
  'hero.stat3Value': '100%',
  'hero.stat3Label': 'Eerlijk & Privé',

  // Features Section
  'features.title1': 'Krachtige functies voor',
  'features.title2': 'moderne',
  'features.title3': 'bedrijven',
  'features.honestVerdict.title': 'Eerlijk oordeel, geen hype-score',
  'features.honestVerdict.description': 'Heldere goed/gemiddeld/zwak-oordelen op basis van echte marktdata en concurrentieonderzoek. Geen 9/10-beoordelingen die elk idee vleien.',
  'features.fullJourney.title': 'Van idee-check tot Builder Report',
  'features.fullJourney.description': 'Valideer in de chat, verdiep je in de marktanalyse, exporteer een Builder Report van 25–75 pagina’s met persona’s, financiën, go-to-market en pitch deck.',
  'features.multilingual.title': '21 talen, lokale marktdata',
  'features.multilingual.description': 'Van Zwitsers MKB tot solo-founder in São Paulo — de AI antwoordt in jouw taal, met bronnen uit jouw markt.',

  // How It Works
  'howItWorks.title': 'Hoe het werkt',
  'howItWorks.subtitle': 'Vier stappen naar duidelijkheid over uw zakelijke niche.',
  'howItWorks.step1Title': 'Kies een plan',
  'howItWorks.step1Desc': 'Starter, Pro or Builder – afhankelijk van de diepte van uw beoordeling.',
  'howItWorks.step2Title': 'Vraag de AI',
  'howItWorks.step2Desc': 'Stel uw vragen over de niche. Elk verzoek kost 30 credits.',
  'howItWorks.step3Title': 'Krijg eerlijk oordeel',
  'howItWorks.step3Desc': 'De AI beoordeelt: Goed, Gemiddeld or Slecht. Zonder omwegen.',
  'howItWorks.step4Title': 'Neem een beslissing',
  'howItWorks.step4Desc': 'Nu weet u of het de moeite waard is om door te gaan.',

  // Pricing
  'pricing.title': 'Prijzen',
  'pricing.subtitle': 'Kies het plan dat past bij de diepte van uw beoordeling.',
  'pricing.yearlyDiscount': 'Jaarabonnement:',
  'pricing.yearlyDiscountValue': '-20% korting',
  'pricing.perMonth': 'per maand',
  'pricing.selectPlan': 'Plan selecteren',
  'pricing.mostPopular': 'Meest populair',
  'pricing.footer': 'Alle prijzen in CHF. Credits worden alleen afgetrokken voor succesvolle AI-antwoorden.',
  
  // Starter Plan
  'pricing.starter.name': 'Starter',
  'pricing.starter.description': 'Voor eerste realiteitstests.',
  'pricing.starter.credits': '2.500 credits',
  'pricing.starter.feature1': 'Niche-idee genereren',
  'pricing.starter.feature2': 'Niche verfijnen',
  'pricing.starter.feature3': 'Marktrealiteitscheck',
  'pricing.starter.feature4': 'Concurrentiebeoordeling',
  'pricing.starter.feature5': 'Timingbeoordeling',
  'pricing.starter.feature6': 'Eerlijk oordeel',
  'pricing.starter.feature7': 'Privésessies',
  'pricing.starter.feature8': 'Geschiedenis en export',

  // Pro Plan
  'pricing.pro.name': 'Pro',
  'pricing.pro.description': 'Voor diepere beoordeling.',
  'pricing.pro.credits': '5.000 credits',
  'pricing.pro.feature1': 'Alle Starter-functies',
  'pricing.pro.feature2': 'Meer credits voor intensieve beoordeling',
  'pricing.pro.feature3': 'Verbeteringsuggesties',
  'pricing.pro.feature4': 'Alternatieve niches',
  'pricing.pro.feature5': 'Gedetailleerde marktanalyse',
  'pricing.pro.feature6': 'Prioriteitsondersteuning',
  'pricing.pro.feature7': 'Geavanceerde filters',
  'pricing.pro.feature8': 'Sessiefavorieten',

  // Builder Plan
  'pricing.builder.name': 'Builder',
  'pricing.builder.description': 'Idee → Ontwikkelaarsbriefing.',
  'pricing.builder.credits': 'Onbeperkte credits',
  'pricing.builder.feature1': 'Alle Pro-functies',
  'pricing.builder.feature2': 'Onbeperkte AI-verzoeken',
  'pricing.builder.feature3': 'Builder-modus: Ontwikkelaarsbriefing',
  'pricing.builder.feature4': 'Gestructureerd projectoverzicht',
  'pricing.builder.feature5': 'Gebruikersstromen en kernfuncties',
  'pricing.builder.feature6': 'Technische notities',
  'pricing.builder.feature7': 'Niet-doelen definiëren',
  'pricing.builder.feature8': 'Fair use-tariefbeperking',
  'pricing.builder.limitNote': 'Fair use-limiet',
  'pricing.monthlyReset': 'Maandelijkse reset',

  // Modal
  'pricing.modal.selected': 'geselecteerd',
  'pricing.modal.comingSoon': 'Registratie en betalingsverwerking zullen binnenkort beschikbaar zijn.',
  'pricing.modal.patience': 'We werken eraan om u een veilige en naadloze ervaring te bieden. Wees alstublieft geduldig.',
  'pricing.modal.understood': 'Begrepen',

  // FAQ
  'faq.title': 'FAQ',
  'faq.subtitle': 'Eerlijk en kritisch beantwoord.',
  'faq.q1': 'Wat doet IdeaOracle.ai concreet?',
  'faq.a1': 'IdeaOracle.ai beoordeelt bedrijfsideeën en niches op marktlogica, reële vraag, concurrentie, differentiatie en haalbaarheid.\nAls er substantie is, laten we zien hoe het strategisch kan worden aangescherpt.\nZo niet, dan zeggen we dat.',
  'faq.q2': 'Genereren jullie ook ideeën?',
  'faq.a2': 'Ja.\nMaar niet blind.\nWe ontwikkelen benaderingen op basis van marktlogica – niet vanuit motivatie of trendhype.',
  'faq.q3': 'Optimaliseren jullie bedrijfsmodellen?',
  'faq.a3': 'Ja – als er potentieel is.\nWe polijsten geen illusies.\nWe maken levensvatbare concepten weerbaarder.',
  'faq.q4': 'Wat onderscheidt jullie van andere AI-tools?',
  'faq.a4': 'Andere tools leveren inspiratie.\nWij leveren beoordeling.\nDe focus ligt op realisme, niet op enthousiasme.',
  'faq.q5': 'Is dit een garantie voor succes?',
  'faq.a5': 'Nee.\nWe verminderen slechte beslissingen – we elimineren geen risico.',
  'faq.q6': 'Voor wie is IdeaOracle.ai geschikt?',
  'faq.a6': 'Oprichters voor de lancering\nOndernemers voor expansie\nSide-builders voor tijdsinvestering\nInvesteerders voor beoordeling\n\nKort: Voor mensen die duidelijkheid willen voor kapitaal.',
  'faq.q7': 'Wat als ik alleen bevestiging zoek?',
  'faq.a7': 'Dan is IdeaOracle.ai niet de juiste tool.',
  'faq.q8': 'Hoe eerlijk is de analyse?',
  'faq.a8': 'Zo eerlijk als data en marktmechanica toelaten.\nGeen euforie. Geen genade.',
  'faq.q9': 'Vervangen jullie marktonderzoek?',
  'faq.a9': 'Nee.\nWij zijn een strategische voorbeoordeling – geen volledig marktonderzoek.',
  'faq.q10': 'Waarom zo compromisloos?',
  'faq.a10': 'Omdat falen duur is.\nEerlijkheid niet.',

  // Footer
  'footer.description': 'Dit platform helpt je niet om je goed te voelen – maar om juist te beslissen.',
  'footer.product': 'Product',
  'footer.aiAssistant': 'AI-assistent',
  'footer.howItWorks': 'Hoe het werkt',
  'footer.pricing': 'Prijzen',
  'footer.faq': 'FAQ',
  'footer.legal': 'Juridisch',
  'footer.privacy': 'Privacy',
  'footer.terms': 'Voorwaarden',
  'footer.imprint': 'Colofon',
  'footer.support': 'Ondersteuning',
  'footer.contact': 'Contact',
  'footer.documentation': 'Documentatie',
  'footer.copyright': '© 2025 IdeaOracle.ai. Alle rechten voorbehouden.',

  // AI Assistant
  'aiAssistant.title': 'AI-niche-assistent',
  'aiAssistant.subtitle': 'Vragen over niches',
  'aiAssistant.welcomeMessage': 'Hoi! Beschrijf je idee of vraag me naar een niche. Ik geef je een duidelijke en eerlijke beoordeling.',
  'aiAssistant.demoResponse': 'Dit is een demo. Om echte AI-beoordelingen te krijgen, registreer je en kies je een plan.',
  'aiAssistant.placeholder': 'Beschrijf je idee...',

  // Header & Sidebar
  'dashboard.header.title': 'Dashboard',
  'dashboard.sidebar.overview': 'Overzicht',
  'dashboard.sidebar.newAnalysis': 'AI-assistent',
  'dashboard.sidebar.history': 'Geschiedenis',
  'dashboard.sidebar.credits': 'Credits',
  'dashboard.sidebar.settings': 'Instellingen',

  // Dashboard Overview
  'dashboard.overview.welcome': 'Welkom terug, {{name}}',
  'dashboard.overview.subtitle': 'Hier is een snel overzicht van je activiteit',

  // Dashboard Stats
  'dashboard.stats.creditsRemaining': 'Resterende credits',
  'dashboard.stats.totalAnalyses': 'Totale analyses',
  'dashboard.stats.goodRatings': 'Positieve beoordelingen',
  'dashboard.stats.nextReset': 'Volgende reset over',
  'dashboard.stats.days': 'dagen',

  // Quick Actions
  'dashboard.quickActions.title': 'Snelle acties',
  'dashboard.quickActions.checkNewIdea': 'Controleer een idee',
  'dashboard.quickActions.checkNewIdeaDesc': 'Analyseer een bestaand bedrijfsidee',
  'dashboard.quickActions.generateIdea': 'Genereer een idee',
  'dashboard.quickActions.generateIdeaDesc': 'Vind een nieuwe winstgevende niche',
  'dashboard.quickActions.builderBriefing': 'Builder-briefing',
  'dashboard.quickActions.builderBriefingDesc': 'Verander een idee in een ontwikkelaar-klare briefing',
  'dashboard.quickActions.premiumOnly': 'Alleen Builder',

  // Chat Header
  'chat.title': 'AI-niche-assistent',
  'chat.subtitle': 'Stel vragen over niches. Ik beoordeel kritisch en eerlijk.',
  'chat.creditsLabel': 'Credits',

  // Chat Welcome
  'chat.welcomeTitle': 'Welkom bij de AI-niche-assistent',
  'chat.welcomeDesc': 'Beschrijf je idee of vraag naar een niche. Ik beoordeel het eerlijk: Goed, Gemiddeld or Slecht.',
  'chat.aiWelcome': 'Hoi! Beschrijf je idee of vraag me naar een niche. Ik geef je een duidelijke en eerlijke beoordeling.',

  // Chat Suggestions
  'chat.suggestion1': 'Vind me een winstgevende niche.',
  'chat.suggestion2': 'Ik heb een idee – beoordeel het eerlijk.',
  'chat.suggestion3': 'Welke niches hebben nu potentieel?',
  'chat.suggestion4': 'Verfijn deze niche en maak het specifieker.',

  // Chat Actions
  'chat.newConversation': 'Nieuw gesprek',
  'chat.today': 'Vandaag',
  'chat.yesterday': 'Gisteren',
  'chat.thisWeek': 'Deze week',
  'chat.thisMonth': 'Deze maand',
  'chat.older': 'Ouder',
  'chat.messages': 'berichten',
  'chat.renameConversation': 'Hernoemen',
  'chat.deleteConversation': 'Verwijderen',
  'chat.cancel': 'Annuleren',
  'chat.rename': 'Hernoemen',
  'chat.delete': 'Verwijderen',
  'chat.favorite': 'Favoriet toevoegen',
  'chat.unfavorite': 'Favoriet verwijderen',
  'chat.searchSessions': 'Gesprekken zoeken...',
  'chat.noResults': 'Geen resultaten gevonden',
  'chat.noSessions': 'Nog geen gesprekken',
  'chat.enterNewName': 'Voer een nieuwe naam in...',
  'chat.deleteConfirmMessage': 'Weet je zeker dat je dit gesprek wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',

  // Chat Input & Errors
  'chat.inputPlaceholder': 'Typ je vraag… (kost 30 credits)',
  'chat.send': 'Verzenden',
  'chat.voice': 'Spreken',
  'chat.listeningPlaceholder': 'Ik luister... Spreek nu.',
  'chat.stopListening': 'Stop opname',
  'chat.recording': 'Opnemen...',
  'chat.speechNotSupported': 'Spraakherkenning wordt niet ondersteund door uw browser.',
  'chat.microphonePermissionDenied': 'Microfoontoegang is geweigerd. Sta toegang toe in uw browserinstellingen.',
  'chat.errorNotEnoughCredits': 'Niet genoeg credits. Upgrade uw plan of wacht op de volgende reset.',
  'chat.errorAiFailed': 'AI-antwoord mislukt. Er zijn geen credits afgetrokken.',
  'chat.errorRateLimit': 'Te veel verzoeken. Wacht even.',

  // Ratings
  'rating.good': 'Goed',
  'rating.medium': 'Gemiddeld',
  'rating.bad': 'Slecht',

  // Auth Page
  'auth.branding.headline1': 'Niet elk idee is goed.',
  'auth.branding.headline2': 'We vertellen je eerlijk welke.',
  'auth.branding.subtitle': 'Een beslissings-AI voor zakelijke niches. Helder. Kritisch. Zonder omwegen.',
  'auth.benefits.privacy.title': '100% Privé',
  'auth.benefits.privacy.desc': 'Je ideeën blijven volledig privé en veilig.',
  'auth.benefits.honest.title': 'Eerlijke AI',
  'auth.benefits.honest.desc': 'Zonder omwegen – alleen heldere, kritische feedback.',
  'auth.benefits.fast.title': 'Snelle Resultaten',
  'auth.benefits.fast.desc': 'Krijg duidelijkheid over je niche in minuten.',
  'auth.trust.users': 'Actieve Gebruikers',
  'auth.trust.ideas': 'Geanalyseerde Ideeën',
  'auth.trust.rating': 'Beoordeling',
  'auth.login.title': 'Inloggen',
  'auth.login.headline': 'Welkom terug',
  'auth.login.subtitle': 'Log in om je reis voort te zetten.',
  'auth.login.forgotPassword': 'Wachtwoord vergeten?',
  'auth.login.submit': 'Inloggen',
  'auth.login.noAccount': 'Nog geen account?',
  'auth.login.signUp': 'Registreren',
  'auth.register.title': 'Registreren',
  'auth.register.headline': 'Maak je account aan',
  'auth.register.subtitle': 'Begin vandaag met het analyseren van je bedrijfsideeën.',
  'auth.register.submit': 'Account Aanmaken',
  'auth.register.hasAccount': 'Heb je al een account?',
  'auth.register.signIn': 'Inloggen',
  'auth.fields.name': 'Volledige Naam',
  'auth.fields.email': 'E-mailadres',
  'auth.fields.password': 'Wachtwoord',
  'auth.fields.confirmPassword': 'Bevestig Wachtwoord',
  'auth.fields.selectPlan': 'Selecteer je plan',
  'auth.placeholders.name': 'Voer je naam in',
  'auth.placeholders.email': 'Voer je e-mail in',
  'auth.placeholders.password': 'Voer je wachtwoord in',
  'auth.placeholders.confirmPassword': 'Bevestig je wachtwoord',
  'auth.terms.accept': 'Ik accepteer de',
  'auth.terms.terms': 'Algemene Voorwaarden',
  'auth.privacy.accept': 'Ik accepteer het',
  'auth.privacy.policy': 'Privacybeleid',
  'auth.errors.nameRequired': 'Naam is verplicht',
  'auth.errors.emailRequired': 'E-mail is verplicht',
  'auth.errors.emailInvalid': 'Voer een geldig e-mailadres in',
  'auth.errors.passwordRequired': 'Wachtwoord is verplicht',
  'auth.errors.passwordLength': 'Wachtwoord moet minimaal 8 tekens bevatten',
  'auth.errors.passwordMismatch': 'Wachtwoorden komen niet overeen',
  'auth.loading': 'Even geduld...',
  'auth.or': 'of doorgaan met',
  'auth.social.google': 'Doorgaan met Google',
  'auth.social.apple': 'Doorgaan met Apple',

  // Trial Plan
  'pricing.trial.name': 'Trial',
  'pricing.trial.description': '3 dagen gratis toegang',
  'pricing.trial.credits': '250 credits',
  'pricing.trial.free': 'Gratis',
  'pricing.trial.duration': '3 dagen zonder kosten',
  'pricing.trial.cta': 'Start gratis proefperiode',
  'pricing.trial.feature1': '250 credits om de AI te ontdekken',
  'pricing.trial.feature2': 'Volledige toegang voor 3 dagen',
  'pricing.trial.feature3': 'Geen creditcard vereist',
  'pricing.trial.feature4': 'Op elk moment opzegbaar',

  // Gold Package
  'pricing.gold.name': 'Gold',
  'pricing.gold.description': '10.000 credits + Builder-rapport van 25 pagina\'s',
  'pricing.gold.credits': '10.000 credits',
  'pricing.gold.feature1': '10.000 credits',
  'pricing.gold.feature2': 'Builder-rapport van 25 pagina\'s',
  'pricing.gold.feature3': 'Alle Starter- en Pro-functies',
  'pricing.gold.feature4': 'Marktanalyse & samenvatting',
  'pricing.gold.feature5': 'Kansen, risico\'s, aanbevelingen',
  'pricing.gold.feature6': 'PDF downloaden',
  'pricing.gold.feature7': 'Ondersteuning',

  // Platinum Package
  'pricing.platinum.name': 'Platinum',
  'pricing.platinum.description': '15.000 credits + Builder-rapport van 100 pagina\'s',
  'pricing.platinum.credits': '15.000 credits',
  'pricing.platinum.feature1': '15.000 credits',
  'pricing.platinum.feature2': 'Builder-rapport van 100 pagina\'s',
  'pricing.platinum.feature3': 'Alle Gold-functies',
  'pricing.platinum.feature4': 'Builder-modus: ontwikkelaarsbriefings',
  'pricing.platinum.feature5': 'Gestructureerde samenvatting',
  'pricing.platinum.feature6': 'Geavanceerde marktanalyse',
  'pricing.platinum.feature7': 'Ondersteuning',

  // Pricing UI
  'pricing.monthly': 'Maandelijks',
  'pricing.yearly': 'Jaarlijks',
  'pricing.savings': 'besparing',
  'pricing.billedYearly': 'Jaarlijks gefactureerd',

  // Hero trial CTA
  'hero.trialTitle': 'Start je gratis proefperiode',
  'hero.creditsLabel': 'Credits',
  'hero.trialTagline': 'Probeer onze AI-assistent 3 dagen gratis',
  'hero.trialCta': 'Meld je aan & krijg 250 credits',
  'hero.trialNoCard': 'Geen creditcard vereist. Geen verplichting.',

  // Admin
  'admin.dashboard.tabs.plans': 'Abonnementen',

  // Credit top-up
  'dashboard.credits.topup.button': 'Credits opwaarderen',
  'dashboard.credits.topup.buttonTitle': 'Koop extra credits zonder van abonnement te wisselen',
  'dashboard.credits.topup.title': 'Credits opwaarderen',
  'dashboard.credits.topup.subtitle': 'CHF 0,15 per credit — geen abonnementswijziging nodig',
  'dashboard.credits.topup.quickAmounts': 'Snelle keuze',
  'dashboard.credits.topup.custom': 'Aangepast',
  'dashboard.credits.topup.totalLabel': 'Totaal',
  'dashboard.credits.topup.creditsLabel': 'Credits',
  'dashboard.credits.topup.confirm': 'Nu kopen',
  'footer.disclaimer': 'Disclaimer',
  'legal.backToHome': 'Terug naar home',
  'legal.lastUpdated': 'Laatst bijgewerkt',
  'legal.allRightsReserved': 'Alle rechten voorbehouden.',
  'legal.authoritativeNotice': 'Een gelokaliseerde versie in jouw taal is nog niet beschikbaar. De Engelse authentieke tekst wordt hieronder getoond.',
  'legal.translationNotice': 'Dit is een vertaling voor het gemak. De Engelse versie is het juridisch bindende origineel.',
};

export default common;
